export const SERVICOS = [
  {
    id: "gas",
    num: "01",
    title: "Inspeções de Gás",
    desc: "Inspeção periódica e extraordinária de instalações de gás em edifícios de habitação, comércio e indústria, conforme legislação em vigor.",
    img: "/api/uploads/service-gas.jpg",
  },
  {
    id: "eletrica",
    num: "02",
    title: "Inspeções Elétricas",
    desc: "Verificação de instalações elétricas de serviço particular e certificação de conformidade com o RTIEBT.",
    img: "/api/uploads/service-eletrica.jpg",
  },
  {
    id: "elevadores",
    num: "03",
    title: "Inspeções de Elevadores",
    desc: "Inspeção periódica de ascensores, monta-cargas, escadas mecânicas e tapetes rolantes ao abrigo do DL 320/2002.",
    img: "/api/uploads/service-elevadores.jpg",
  },
  {
    id: "energetica",
    num: "04",
    title: "Certificação Energética",
    desc: "Emissão de certificados energéticos SCE para edifícios de habitação, comércio e serviços, com propostas de melhoria.",
    img: "/api/uploads/service-energetica.jpg",
  },
  {
    id: "pressao",
    num: "05",
    title: "Equipamentos Sob Pressão",
    desc: "Aprovação de instalação e inspeções periódicas de reservatórios de ar comprimido, geradores de vapor e ESP industriais.",
    img: "/api/uploads/service-pressao.jpg",
  },
  {
    id: "drone",
    num: "06",
    title: "Termografia por Drone",
    desc: "Inspeção termográfica aérea de coberturas, fachadas, painéis fotovoltaicos e infraestruturas de difícil acesso.",
    img: "/api/uploads/service-drone.jpg",
  },
  {
    id: "auditoria",
    num: "07",
    title: "Auditorias de Conformidade",
    desc: "Diagnóstico legal completo dos seus ativos: identificação das obrigações aplicáveis e plano de regularização.",
    img: "/api/uploads/service-auditoria.jpg",
  },
  {
    id: "ambiente",
    num: "08",
    title: "Ruído & Qualidade do Ar",
    desc: "Medições acústicas, avaliação de ruído ambiental e monitorização da qualidade do ar interior (QAI).",
    img: "/api/uploads/service-ambiente.jpg",
  },
];

export const CERTIFICACOES = [
  {
    sigla: "EIG",
    title: "Entidade Inspetora de Gás",
    detail: "Autorização DGEG · Acreditação IPAC",
    ref: "Gasmed I0016",
  },
  {
    sigla: "ESP",
    title: "Equipamentos Sob Pressão",
    detail: "Autorização IPQ · Acreditação IPAC",
    ref: "Gasmed I0016",
  },
  {
    sigla: "EIC",
    title: "Entidade Inspetora de Combustíveis",
    detail: "Autorização DGEG · Acreditação IPAC",
    ref: "Hotinspe I0032",
  },
  {
    sigla: "OED",
    title: "Equipamentos de Diversão",
    detail: "Acreditação IPAC",
    ref: "Hotinspe I0032",
  },
];

export const SERVICO_DETALHES = {
  gas: {
    inclui: [
      "Inspeção periódica de instalações em habitações unifamiliares e coletivas",
      "Inspeção de instalações do setor terciário (cafés, restaurantes, comércio)",
      "Inspeção de instalações de gás industriais",
      "Inspeção de colunas montantes e instalações comuns de edifícios",
      "Inspeção extraordinária após alteração da instalação ou dos aparelhos",
      "Deteção e localização de fugas de gás",
      "Apreciação de projetos de instalações de gás",
      "Reinspeções e acompanhamento da regularização de anomalias",
    ],
    enquadramento: ["DL n.º 97/2017", "Acreditação IPAC · ISO/IEC 17020", "Reconhecimento DGEG · EIG"],
    periodicidade: "Em função da idade da instalação e do tipo de utilização — prazos reduzidos no setor terciário e industrial.",
    destinatarios: ["Habitação", "Condomínios", "Restauração", "Indústria", "Distribuidoras"],
  },
  eletrica: {
    inclui: [
      "Inspeção de instalações elétricas de serviço particular",
      "Verificações periódicas de instalações em exploração",
      "Ensaios de terra, isolamento e continuidade",
      "Verificação de quadros elétricos e proteções diferenciais",
      "Relatórios de conformidade com o RTIEBT",
      "Acompanhamento da correção de não conformidades",
    ],
    enquadramento: ["RTIEBT · Portaria n.º 949-A/2006", "DL n.º 96/2017"],
    periodicidade: "Periódica, em função da categoria e da potência da instalação.",
    destinatarios: ["Empresas", "Condomínios", "Indústria", "Municípios"],
  },
  elevadores: {
    inclui: [
      "Inspeção periódica de ascensores e monta-cargas",
      "Inspeção de escadas mecânicas e tapetes rolantes",
      "Reinspeções após correção de deficiências",
      "Inquéritos a acidentes e avarias graves",
      "Emissão do certificado e selo de inspeção",
    ],
    enquadramento: ["DL n.º 320/2002"],
    periodicidade: "2, 4 ou 6 anos, consoante o tipo de equipamento e o edifício onde está instalado.",
    destinatarios: ["Condomínios", "Edifícios de serviços", "Municípios", "Centros comerciais"],
  },
  energetica: {
    inclui: [
      "Emissão de certificados energéticos SCE (escala F a A+)",
      "Análise de isolamento, ventilação e climatização",
      "Avaliação do consumo energético do imóvel",
      "Recomendações de melhoria com estimativa de poupança",
      "Apoio no acesso a incentivos e financiamento",
    ],
    enquadramento: ["SCE · DL n.º 101-D/2020", "Peritos qualificados ADENE"],
    periodicidade: "Validade de 10 anos (habitação) e 6 anos (grandes edifícios de serviços). Emissão até 5 dias úteis.",
    destinatarios: ["Venda e arrendamento", "Habitação", "Comércio e serviços"],
  },
  pressao: {
    inclui: [
      "Inspeção inicial e aprovação da instalação de reservatórios de GPL",
      "Inspeções intercalares e periódicas ao longo da vida útil",
      "Verificação de zonas e distâncias de segurança",
      "Ensaios de estanquidade e verificação dos acessórios de segurança",
      "Inspeção de parques de armazenamento de garrafas de GPL",
    ],
    enquadramento: ["Autorização IPQ", "Acreditação IPAC · ESP", "DL n.º 90/2010"],
    periodicidade: "Inspeções iniciais, intercalares e periódicas conforme o plano de inspeção do equipamento.",
    destinatarios: ["Indústria", "Postos de abastecimento", "Parques de GPL", "Unidades hoteleiras"],
  },
  drone: {
    inclui: [
      "Termografia aérea de coberturas e fachadas",
      "Inspeção de painéis fotovoltaicos e parques solares",
      "Inspeção de infraestruturas de difícil acesso",
      "Deteção de patologias, infiltrações e perdas térmicas",
      "Relatório termográfico com mapeamento georreferenciado",
    ],
    enquadramento: ["Pilotos certificados pela ANAC", "Serviço voluntário não regulamentado"],
    periodicidade: "Pontual ou em planos de monitorização periódica definidos com o cliente.",
    destinatarios: ["Indústria", "Energia solar", "Condomínios", "Municípios"],
  },
  auditoria: {
    inclui: [
      "Diagnóstico legal completo dos ativos e das atividades",
      "Levantamento das obrigações legais aplicáveis e respetivos prazos",
      "Plano de regularização priorizado",
      "Inspeção de sistemas de segurança contra incêndio em edifícios (SCIE): deteção, desenfumagem, extinção e iluminação de emergência",
      "Planeamento e coordenação de simulacros",
      "Inspeção de armazenamento de produtos químicos perigosos",
      "Verificação de equipamentos de trabalho por pessoa competente",
    ],
    enquadramento: ["DL n.º 220/2008 · RJSCIE", "Portaria n.º 1532/2008", "DL n.º 50/2005", "Reg. CE 1272/2008"],
    periodicidade: "Auditoria inicial com acompanhamento anual ou conforme o plano de conformidade.",
    destinatarios: ["Empresas", "Indústria", "Setor público", "Grandes edifícios"],
  },
  ambiente: {
    inclui: [
      "Medições acústicas e avaliação de ruído ambiental",
      "Avaliação do critério de incomodidade sonora",
      "Monitorização da qualidade do ar interior (QAI)",
      "Medição de parâmetros físico-químicos e microbiológicos",
      "Relatórios técnicos com medidas corretivas",
    ],
    enquadramento: ["Regulamento Geral do Ruído · DL n.º 9/2007", "Portaria n.º 138-G/2021 · QAI"],
    periodicidade: "Pontual (licenciamento, reclamações) ou monitorização periódica.",
    destinatarios: ["Indústria", "Restauração", "Edifícios de serviços", "Municípios"],
  },
};

export const SETORES = [
  { label: "Habitação", icon: "Home" },
  { label: "Condomínios", icon: "Building2" },
  { label: "Empresas", icon: "Briefcase" },
  { label: "Indústria", icon: "Factory" },
  { label: "Municípios", icon: "Landmark" },
];

export const STATS = [
  { value: "+25", label: "Anos de experiência" },
  { value: "+200.000", label: "Clientes satisfeitos" },
  { value: "100%", label: "Taxa de Satisfação" },
  { value: "24h", label: "Tempo médio de resposta" },
];

export const MANIFESTO = [
  {
    num: "01",
    title: "O Grupo",
    text: "A INXPEK resulta da união entre a Gasmed e a Hotinspe, empresas que integram um grupo empresarial comum com décadas de experiência em inspeção técnica. Esta sinergia traduz-se em maior cobertura geográfica, maior capacidade de resposta, mais recursos e um leque alargado de serviços de inspeção — com +300.000 consumidores em segurança.",
  },
  {
    num: "02",
    title: "Certificações",
    text: "Somos reconhecidos como Entidade Inspetora pela Direção-Geral de Energia e Geologia (DGEG) e como Organismo de Inspeção acreditado pelo Instituto Português de Acreditação (IPAC) — acreditações I0016 (Gasmed) e I0032 (Hotinspe) — com autorização do IPQ para equipamentos sob pressão. Rigor, imparcialidade e qualidade são garantias formais, não promessas.",
  },
  {
    num: "03",
    title: "Oportunidades",
    text: "Procuramos engenheiros, inspetores e técnicos que queiram crescer connosco. Se a precisão é a sua linguagem, envie a sua candidatura para careers@inxpek.pt.",
  },
];
